/* PagingNetworkDiscoveryFeed.js */

"use strict";
const PagingFeed = require("../../../../lib/PagingFeed");
//const _ = require('lodash');

class PagingNetworkDiscoveryFeed extends PagingFeed {
    _getFeed() {
        return this._EntityDef.startNetworkDiscoveryPlansFeed(
            this._userSession.activeOrganization.id,
            this._filter,
            this._entityFields,
            this._sort,
            {
                skip: 0,
                limit: this._pageSize * 2,
            }
        );
    }

    _getFeedIdsForSelection(tenantId, selection) {
        return this._EntityDef.loadNetworkDiscoveryPlanIdsForSelection(tenantId, selection);
    }

    getNetworkDiscoveryEntitiesById(ids) {
        return this.getEntitiesById(ids);
    }

    getNetworkDiscoveryEntitiesNameById(ids) {
        return this.getEntitiesValueByIdAsProm(ids, "name");
        // return this.getEntitiesNameById(ids);
    }

    getNetworkDiscoveryEntityById(id) {
        return this.getEntityById(id);
    }
}

module.exports = PagingNetworkDiscoveryFeed;
